import 'picturefill';
import 'lazysizes';
/**
 * 画像ヒラヒラクラス
 */
var FallImages = function (imageEl, canvasID) {
    this.canvasEl = document.getElementById(canvasID);
    this.context = this.canvasEl.getContext('2d');
    this.imageEl = imageEl;
    this.radian = Math.PI / 180;
    this.init();
};
// 初期化
FallImages.prototype.init = function () {
    this.updateImageSize();
    this.updateCanvasSize();
};
// 画像サイズのアップデート
FallImages.prototype.updateImageSize = function () {
    document.body.appendChild(this.imageEl);
    this.imageSize = {
        width: this.imageEl.clientWidth,
        height: this.imageEl.clientHeight,
    };
    // 横幅に対する高さの割合を求める
    this.imageSize.aspectHeight = this.imageSize.height / this.imageSize.width;
    document.body.removeChild(this.imageEl);
};
// キャンバスサイズのアップデート
FallImages.prototype.updateCanvasSize = function () {
    var viewportWidth = document.documentElement.clientWidth;
    this.canvasEl.width = viewportWidth;
    this.canvasSize = {
        width: this.canvasEl.clientWidth,
        height: this.canvasEl.clientHeight
    };
};
// 画像のプロパティリストを生成
FallImages.prototype.createImagePropList = function (numImages) {
    this.imagePropList = new Array(numImages);
    for (var i = 0; i < numImages; i++) {
        var imageSize = this.getRandomImageSize();
        this.imagePropList[i] = {
            x: Math.random() * this.canvasSize.width,
            y: Math.random() * this.canvasSize.height,
            width: imageSize.width,
            height: imageSize.height,
            speedY: Math.random() * 1 + 0.5,
            angle: Math.random() * 360
        };
    }
};
// 画像の縦横をランダムに返す、アスペクト比は維持する
FallImages.prototype.getRandomImageSize = function () {
    // 画像の横幅をランダムに生成
    var width = Math.floor(Math.random() * this.imageSize.width + this.imageSize.width / 2);
    // 横幅をもとに高さを求める
    var height = width * this.imageSize.aspectHeight;
    return {
        width: width,
        height: height
    };
};
// 落下の描画
FallImages.prototype.drawImages = function () {
    this.context.clearRect(0, 0, this.canvasSize.width, this.canvasSize.height);
    var speedX = Math.random() * (0.0025 * document.documentElement.clientWidth);
    for (var i = 0; i < this.numImages; i++) {
        var prop = this.imagePropList[i];
        var cos = Math.cos(prop.angle * this.radian);
        var sin = Math.sin(prop.angle * this.radian);
        this.context.setTransform(cos, sin, sin, cos, prop.x, prop.y);
        this.context.drawImage(this.imageEl, 0, 0, prop.width, prop.height);
        this.context.setTransform(1, 0, 0, 1, 0, 0);
        // Y座標がキャンバスの外にでたら、上に戻す
        if (prop.y - prop.height > this.canvasSize.height) {
            this.imagePropList[i].y = prop.height * -1;
        }
        // X座標がキャンバスの外にでたら戻す
        if (prop.x - prop.width > this.canvasSize.width) {
            this.imagePropList[i].x = 0;
        }
        // Y軸に落下させる
        this.imagePropList[i].y += prop.speedY;
        this.imagePropList[i].x = prop.x + speedX;
        this.imagePropList[i].angle += Math.random() * 2;
    }
};
// 開始
FallImages.prototype.start = function (numImages) {
    this.numImages = numImages;
    this.createImagePropList(this.numImages);
    var _this = this;
    this.timerID = setInterval(function () {
        _this.drawImages();
    }, 10);
};
// リセット
FallImages.prototype.reset = function () {
    this.context.clearRect(0, 0, this.canvasSize.width, this.canvasSize.height);
    this.updateCanvasSize();
    this.createImagePropList(this.numImages);
    var _this = this;
    clearInterval(this.timerID);
    this.timerID = setInterval(function () {
        _this.drawImages();
    }, 10);
};
window.addEventListener('DOMContentLoaded', function () {
    var image = new Image();
    image.addEventListener('load', function () {
        var fallImages = new FallImages(image, 'js-canvas');
        fallImages.start(10);
        window.addEventListener('resize', function () {
            fallImages.reset();
        });
    });
    image.src = './assets/img/misc/hanabira.png?' + (new Date().getTime());
});
